import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import { NumericFormat } from "react-number-format";
import { Success } from "../../assets/jss/util/messageUtil";

const Themthongkephuongtien = React.memo(function Themthongkephuongtien(props) {
  const { thangnam } = props;
  const [trungtamdangkiem_id, setTrungtamdangkiem_id] = React.useState(0);
  const [xecon, setXecon] = React.useState(0);
  const [xekhach_10_25, setXekhach_10_25] = React.useState(0);
  const [xekhach_26_46, setXekhach_26_46] = React.useState(0);
  const [xekhach_tren46, setXekhach_tren46] = React.useState(0);
  const [xetai_den2, setXetai_den2] = React.useState(0);
  const [xetai_2_7, setXetai_2_7] = React.useState(0);
  const [xetai_7_20, setXetai_7_20] = React.useState(0);
  const [xetai_tren20, setXetai_tren20] = React.useState(0);
  const [xechuyendung, setXechuyendung] = React.useState(0);
  const [somiromooc, setSomiromooc] = React.useState(0);
  const [xecon_kd, setXecon_kd] = React.useState(0);
  const [xekhach_10_25_kd, setXekhach_10_25_kd] = React.useState(0);
  const [xekhach_26_46_kd, setXekhach_26_46_kd] = React.useState(0);
  const [xekhach_tren46_kd, setXekhach_tren46_kd] = React.useState(0);
  const [xetai_den2_kd, setXetai_den2_kd] = React.useState(0);
  const [xetai_2_7_kd, setXetai_2_7_kd] = React.useState(0);
  const [xetai_7_20_kd, setXetai_7_20_kd] = React.useState(0);
  const [xetai_tren20_kd, setXetai_tren20_kd] = React.useState(0);
  const [xechuyendung_kd, setXechuyendung_kd] = React.useState(0);
  const [somiromooc_kd, setSomiromooc_kd] = React.useState(0);
  //const [disableBT, setDisableBT] = React.useState(true);
  const [disableBT1, setDisableBT1] = React.useState(true);
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alert2, setAlert2] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getttdangkiem = () => {
    var url =
      Config.backend +
      "/api/CoSoGTVT/gettrungtamdangkiemtheouser?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTrungtamdangkiem_id(data[0].id);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getthongtin = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend +
        "/api/DangKiemVien/getslthdangkiempl14qd342025userthang?thang=" +
        thang +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setDisableBT1(false);
            setXecon(data[0].xecon);
            setXekhach_10_25(data[0].xekhach_10_25);
            setXekhach_26_46(data[0].xekhach_26_46);
            setXekhach_tren46(data[0].xekhach_tren46);
            setXetai_den2(data[0].xetai_den2);
            setXetai_2_7(data[0].xetai_2_7);
            setXetai_7_20(data[0].xetai_7_20);
            setXetai_tren20(data[0].xetai_tren20);
            setXechuyendung(data[0].xechuyendung);
            setSomiromooc(data[0].somiromooc);
            setXecon_kd(data[0].xecon_kd);
            setXekhach_10_25_kd(data[0].xekhach_10_25_kd);
            setXekhach_26_46_kd(data[0].xekhach_26_46_kd);
            setXekhach_tren46_kd(data[0].xekhach_tren46_kd);
            setXetai_den2_kd(data[0].xetai_den2_kd);
            setXetai_2_7_kd(data[0].xetai_2_7_kd);
            setXetai_7_20_kd(data[0].xetai_7_20_kd);
            setXetai_tren20_kd(data[0].xetai_tren20_kd);
            setXechuyendung_kd(data[0].xechuyendung_kd);
            setSomiromooc_kd(data[0].somiromooc_kd);
          } else {
            setDisableBT1(true);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  const insertphuongtien = () => {
    let mess = validateThem();
    if (mess === Success.SC0001) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend + "/api/DangKiemVien/themslthdangkiempl14qd342025";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          thang: thang,
          trungtamdangkiem_id: trungtamdangkiem_id,
          xecon: xecon,
          xekhach_10_25: xekhach_10_25,
          xekhach_26_46: xekhach_26_46,
          xekhach_tren46: xekhach_tren46,
          xetai_den2: xetai_den2,
          xetai_2_7: xetai_2_7,
          xetai_7_20: xetai_7_20,
          xetai_tren20: xetai_tren20,
          xechuyendung: xechuyendung,
          somiromooc: somiromooc,
          username: username,
          xecon_kd: xecon_kd,
          xekhach_10_25_kd: xekhach_10_25_kd,
          xekhach_26_46_kd: xekhach_26_46_kd,
          xekhach_tren46_kd: xekhach_tren46_kd,
          xetai_den2_kd: xetai_den2_kd,
          xetai_2_7_kd: xetai_2_7_kd,
          xetai_7_20_kd: xetai_7_20_kd,
          xetai_tren20_kd: xetai_tren20_kd,
          xechuyendung_kd: xechuyendung_kd,
          somiromooc_kd: somiromooc,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification2();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const xoaphuongtien = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url = Config.backend + "/api/CoSoGTVT/xoaslthdangkiem";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        thang: thang,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification1();
          setDisableBT1(true);
          setXecon(0);
          setXekhach_10_25(0);
          setXekhach_26_46(0);
          setXekhach_tren46(0);
          setXetai_den2(0);
          setXetai_2_7(0);
          setXetai_7_20(0);
          setXetai_tren20(0);
          setXechuyendung(0);
          setSomiromooc(0);
          setXecon_kd(0);
          setXekhach_10_25_kd(0);
          setXekhach_26_46_kd(0);
          setXekhach_tren46_kd(0);
          setXetai_den2_kd(0);
          setXetai_2_7_kd(0);
          setXetai_7_20_kd(0);
          setXetai_tren20_kd(0);
          setXechuyendung_kd(0);
          setSomiromooc_kd(0);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const showNotification2 = () => {
    setAlert2(true);
    setTimeout(function () {
      setAlert2(false);
    }, 2000);
  };
  const validateThem = () => {
    return Success.SC0001;
  };
  React.useEffect(() => {
    getttdangkiem();
    getthongtin();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Tổng số xe con"
                variant="outlined"
                size="small"
                value={xecon}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXecon(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Số xe con KD"
                variant="outlined"
                size="small"
                value={xecon_kd}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXecon_kd(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Tổng số từ 10 đến 25 chỗ"
                variant="outlined"
                size="small"
                value={xekhach_10_25}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXekhach_10_25(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Số từ 10 đến 25 chỗ KD"
                variant="outlined"
                size="small"
                value={xekhach_10_25_kd}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXekhach_10_25_kd(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Tổng số từ 26 đến 46 chỗ"
                variant="outlined"
                size="small"
                value={xekhach_26_46}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXekhach_26_46(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Từ 26 đến 46 chỗ KD"
                variant="outlined"
                size="small"
                value={xekhach_26_46_kd}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXekhach_26_46_kd(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Tổng số trên 46 chỗ"
                variant="outlined"
                size="small"
                value={xekhach_tren46}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXekhach_tren46(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Trên 46 chỗ KD"
                variant="outlined"
                size="small"
                value={xekhach_tren46_kd}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXekhach_tren46_kd(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Tổng số tải trọng đến 2 tấn"
                variant="outlined"
                size="small"
                value={xetai_den2}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXetai_den2(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Tải trọng đến 2 tấn KD"
                variant="outlined"
                size="small"
                value={xetai_den2_kd}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXetai_den2_kd(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Tổng số tải trọng từ trên 2 tấn đến 7 tấn"
                variant="outlined"
                size="small"
                value={xetai_2_7}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXetai_2_7(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Tải trọng từ trên 2 tấn đến 7 tấn KD"
                variant="outlined"
                size="small"
                value={xetai_2_7_kd}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXetai_2_7_kd(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Tổng số tải trọng từ trên 7 tấn đến 20 tấn"
                variant="outlined"
                size="small"
                value={xetai_7_20}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXetai_7_20(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Tải trọng từ trên 7 tấn đến 20 tấn KD"
                variant="outlined"
                size="small"
                value={xetai_7_20_kd}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXetai_7_20_kd(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Tổng số tải trọng trên 20 tấn, xe đầu kéo"
                variant="outlined"
                size="small"
                value={xetai_tren20}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXetai_tren20(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Tải trọng trên 20 tấn, xe đầu kéo KD"
                variant="outlined"
                size="small"
                value={xetai_tren20_kd}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXetai_tren20_kd(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Tổng số xe chuyên dùng và xe khác"
                variant="outlined"
                size="small"
                value={xechuyendung}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXechuyendung(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Xe chuyên dùng và xe khác KD"
                variant="outlined"
                size="small"
                value={xechuyendung_kd}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setXechuyendung_kd(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Tổng số sơ mi rơ moóc"
                variant="outlined"
                size="small"
                value={somiromooc}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSomiromooc(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Sơ mi rơ moóc KD"
                variant="outlined"
                size="small"
                value={somiromooc_kd}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSomiromooc_kd(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <GridItem xs={12} sm={12} md={3}>
          <FormControl style={{ width: "80%" }}>
            <Button
              color="primary"
              variant="contained"
              style={{ height: 27 }}
              //disabled={disableBT}
              onClick={insertphuongtien}
            >
              Cập nhật
            </Button>
          </FormControl>
        </GridItem>
        <GridItem xs={12} sm={12} md={2}>
          <FormControl style={{ width: "80%" }}>
            <Button
              color="error"
              variant="contained"
              style={{ height: 27 }}
              disabled={disableBT1}
              onClick={xoaphuongtien}
            >
              Xóa
            </Button>
          </FormControl>
        </GridItem>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Xóa thành công"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert2}
            closeNotification={() => setAlert2(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Themthongkephuongtien.propTypes = {
  thangnam: PropTypes.object,
};
export default Themthongkephuongtien;
